import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      height: 'calc(100vh - 400px)',
      '@media (max-width: 1280px)': {
        height: 'auto'
      }
    },
    title: {
      fontStyle: 'italic',
      fontWeight: 700,
      fontSize: '1.5rem',
      color: '#545454',
      '@media (max-width: 1280px)': {
        fontSize: '1.25rem'
      }
    },
    container: {
      display: 'flex',
      justifyContent: 'center',
      gap: '30px',
      alignItems: 'center',
      flexDirection: 'row',
      marginTop: '20px',
      '@media (max-width: 1280px)': {
        flexDirection: 'column'
      }
    },
    button: {
      width: '220px',
      height: '75px',
      boxShadow:
        'inset 4px 4px 4px rgba(255, 255, 255, 0.25), inset 0px 4px 4px rgba(255, 255, 255, 0.25)',
      borderRadius: '10px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '6px 10px 6px 18px',
      cursor: 'pointer',
      transition: '0.3s ease',
      transform: 'scale(1)',
      '&:hover': {
        transform: 'scale(1.1)',
        boxShadow:
          'inset 4px 4px 4px rgba(255, 255, 255, 0.45), inset 0px 4px 4px rgba(255, 255, 255, 0.45)'
      }
    },
    formation: {
      backgroundColor: '#D12C3F'
    },
    challenge: {
      backgroundColor: ' #D78915 '
    },
    pedagogie: {
      backgroundColor: 'rgba(0, 0, 255, 0.9)'
    },
    paragraph: {
      fontStyle: 'italic',
      fontWeight: 700,
      fontSize: '1.25rem',
      color: '#FEFEFE'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
